<script setup>
  import ModalTextInput from '@/components/controls/ModalTextInput.vue';

  const name = defineModel('name');
  const address = defineModel('address');

  defineProps({
    errors: {
      type: Object,
      default: () => ({})
    },
    valid: {
      type: Object,
      default: () => ({})
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  });

  const emits = defineEmits(['delete']);
</script>

<template>
  <div>
    <div class="jwx-modal__section">
      <div class="jwx-modal__section-body">
        <ModalTextInput
          v-model="name"
          id="device-email-name"
          name="device-email-name"
          labelText="Name"
          subText="Max 64 characters"
        />
        <ModalTextInput
          v-model="address"
          id="device-email-address"
          name="device-email-address"
          labelText="Email Address"
          placeholder="email@address.com"
          multi
          required
          :errorText="errors.address"
          :valid="!!valid.address"
        />
      </div>
    </div>
    <div v-if="canDelete" class="jwx-modal__section jwx-p-jumbo jwx-flex jwx-justify-center">
      <button
        type="button"
        class="jwx-button jwx-button--pill"
        data-type="danger"
        @click.prevent="emits('delete')"
      >
        Delete Device
      </button>
    </div>
  </div>
</template>
